import { authClient } from '@/lib/api/ts-rest';
import { useMutation } from '@tanstack/react-query';

export const useRequestPasswordReset = () => {
  const mutation = useMutation({
    mutationFn: (email: string) =>
      authClient.requestPasswordReset({ body: { email } }).catch(() => {
        // Silently catch errors to avoid leaking whether the email exists
      }),
  });

  return {
    requestReset: mutation.mutate,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
};
